// extracted by mini-css-extract-plugin
export default {"container":"BlandWelcome_container__VmuPg","header":"BlandWelcome_header__+YbDK","logo":"BlandWelcome_logo__ac+8b","welcomeMessage":"BlandWelcome_welcomeMessage__I9vdV"};